/**
 * Mailtext an die verfügbare Breite anpassen (Handy, Tablet, schmales Panel).
 *
 * Der Lese-iframe scrollt nie selbst (`scrolling="no"`, s. SandboxedMailBody)
 * — was breiter ist als der Lesebereich, wurde bisher rechts abgeschnitten.
 * Geschäftsmails und Newsletter sind Tabellenlayouts von 600–900 px; auf einem
 * 390-px-iPhone fehlte damit gut die Hälfte. Outlook mobil verkleinert solche
 * Mails auf die Bildschirmbreite; genau das passiert hier.
 *
 * Zuerst wird umbrochen, was sich umbrechen lässt (lange Wörter/Links,
 * `<pre>`, zu breite Bilder) — erst was dann noch übersteht, wird skaliert.
 */

/** Unter diesen Faktor wird nicht verkleinert — darunter ist nichts mehr lesbar. */
export const MIN_SKALIERUNG = 0.3;

/**
 * Faktor, mit dem der Inhalt verkleinert werden muss, damit `inhaltBreite` in
 * `verfuegbar` passt. 1 = passt (ein paar Pixel Überstand werden geduldet,
 * Rundung und Rahmen sollen keine Mini-Verkleinerung auslösen).
 */
export function berechneSkalierung(
    inhaltBreite: number,
    verfuegbar: number,
    min = MIN_SKALIERUNG,
): number {
    if (!Number.isFinite(inhaltBreite) || !Number.isFinite(verfuegbar)) return 1;
    if (verfuegbar <= 0 || inhaltBreite <= verfuegbar + 4) return 1;
    return Math.max(min, verfuegbar / inhaltBreite);
}

/**
 * Umbruch-Regeln, die in den Mail-iframe kommen. `break-word` (nicht
 * `anywhere`) verändert die Mindestbreite von Tabellenzellen nicht — das
 * Layout einer Tabellen-Mail bleibt, wie es ist.
 */
export const MAIL_UMBRUCH_CSS =
    "body{overflow-wrap:break-word;word-wrap:break-word;-webkit-text-size-adjust:100%}" +
    "pre{white-space:pre-wrap}";
